(function() {
  'use strict';

  var STORAGE_KEY = 'utl_timezone_preference';
  var DEFAULT_BROWSER_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

  var TZ_OPTIONS = [
    { value: '_browser', label: 'Use my device timezone' },
    { value: 'America/Los_Angeles', label: 'Los Angeles (PT)' },
    { value: 'America/Denver', label: 'Denver (MT)' },
    { value: 'America/Chicago', label: 'Chicago (CT)' },
    { value: 'America/New_York', label: 'New York (ET)' },
    { value: 'America/Sao_Paulo', label: 'Sao Paulo (BRT)' },
    { value: 'Europe/London', label: 'London (GMT/BST)' },
    { value: 'Europe/Paris', label: 'Paris (CET/CEST)' },
    { value: 'Asia/Kolkata', label: 'Kolkata (IST)' },
    { value: 'Asia/Bangkok', label: 'Bangkok (ICT)' },
    { value: 'Asia/Singapore', label: 'Singapore (SGT)' },
    { value: 'Asia/Kuala_Lumpur', label: 'Kuala Lumpur (MYT)' },
    { value: 'Asia/Tokyo', label: 'Tokyo (JST)' },
    { value: 'Asia/Seoul', label: 'Seoul (KST)' },
    { value: 'Asia/Shanghai', label: 'Shanghai (CST)' },
    { value: 'Australia/Sydney', label: 'Sydney (AET)' },
    { value: 'Pacific/Auckland', label: 'Auckland (NZT)' }
  ];

  function getStoredPreference() {
    try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }

  function getActiveTz() {
    var stored = getStoredPreference();
    if (!stored || stored === '_browser') return DEFAULT_BROWSER_TZ;
    return stored;
  }

  function setStoredPreference(value) {
    try { localStorage.setItem(STORAGE_KEY, value); } catch (e) {}
  }

  function formatTime(dt, tz) {
    var opts = { hour: 'numeric', minute: '2-digit', hour12: true, timeZone: tz };
    return new Intl.DateTimeFormat('en-US', opts).format(dt).replace(/\s/g, '');
  }

  function formatTzAbbr(dt, tz) {
    var parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, timeZoneName: 'short' }).formatToParts(dt);
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].type === 'timeZoneName') return parts[i].value;
    }
    return '';
  }

  function formatOndemandDesc(dt, tz) {
    var dateOpts = { month: 'long', day: 'numeric', timeZone: tz };
    var datePart = new Intl.DateTimeFormat('en-US', dateOpts).format(dt);
    return datePart + ', ' + formatTime(dt, tz) + ' ' + formatTzAbbr(dt, tz);
  }

  function updateAll(tz) {
    // Live class times
    var liveItems = document.querySelectorAll('.utl-class-time[data-datetime]');
    for (var i = 0; i < liveItems.length; i++) {
      var iso = liveItems[i].getAttribute('data-datetime');
      var dt = new Date(iso);
      if (isNaN(dt)) continue;
      var tEl = liveItems[i].querySelector('.utl-time-value');
      var zEl = liveItems[i].querySelector('.utl-tz-badge');
      if (tEl) tEl.textContent = formatTime(dt, tz);
      if (zEl) zEl.textContent = formatTzAbbr(dt, tz);
    }
    // On-demand descriptions
    var recItems = document.querySelectorAll('.utl-ondemand-desc[data-datetime]');
    for (var j = 0; j < recItems.length; j++) {
      var iso2 = recItems[j].getAttribute('data-datetime');
      var dt2 = new Date(iso2);
      if (isNaN(dt2)) continue;
      recItems[j].textContent = formatOndemandDesc(dt2, tz);
    }
  }

  function initSelector() {
    var select = document.getElementById('utl-tz-select');
    if (!select) return;
    // Populate options
    var stored = getStoredPreference();
    var initialValue = stored || '_browser';
    for (var i = 0; i < TZ_OPTIONS.length; i++) {
      var opt = document.createElement('option');
      opt.value = TZ_OPTIONS[i].value;
      opt.textContent = TZ_OPTIONS[i].value === '_browser'
        ? TZ_OPTIONS[i].label + ' (' + DEFAULT_BROWSER_TZ + ')'
        : TZ_OPTIONS[i].label;
      if (TZ_OPTIONS[i].value === initialValue) opt.selected = true;
      select.appendChild(opt);
    }
    select.addEventListener('change', function() {
      setStoredPreference(select.value);
      updateAll(getActiveTz());
    });
  }

  function init() {
    initSelector();
    updateAll(getActiveTz());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
